<div class="tw-bg-blue-200 tw-p-2">
  If you want customers choose among multiple menu items (i.e. Meal), Do Not create menu item, instead create a
  promotion
</div>
<p-splitter [style]="{ minHeight: '300px' }" styleClass="tw-mb-5" [panelSizes]="[15, 20, 45, 20]">
  <ng-template pTemplate>
    <p-table [value]="menus" class="tw-w-full">
      <ng-template pTemplate="caption">
        <div class="flex align-items-center justify-content-between">
          Menus
          <p-button icon="pi pi-plus tw-text-sm" (click)="selectMenu()" />
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th></th>
          <th>Name</th>
          <th>Options</th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-menu>
        <tr [class.!tw-bg-green-300]="menu.Id == _menu?.Id" [class.!tw-bg-gray-300]="_item?.MenuIds.includes(menu.Id)">
          <td></td>
          <td [routerLink]="[basePath,'menu',businessId,'panel','menu',menu.Id]" class="tw-cursor-pointer">
            @if(_menu?.Id == menu.Id){<i class="pi pi-check-circle text-success tw-mr-2"></i>}
            @if(_item?.MenuIds.includes(menu.Id)){<i class="pi pi-check tw-mr-2"></i>}
            {{menu.Name}}
          </td>
          <td>{{menu.Options?.length}}</td>
          <td>
            <p-menu #actionMenu [model]="menu._actions" [popup]="true" appendTo="body"></p-menu>
            <i (click)="actionMenu.toggle($event)" [id]="'action-menu-'+menu.Id"
              class="pi pi-ellipsis-h tw-text-sm tw-cursor-pointer"></i>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </ng-template>

  <ng-template pTemplate>

    <p-table [value]="items" class="tw-w-full">
      <ng-template pTemplate="caption">
        <div class="flex align-items-center justify-content-between">
          Menu Items
          <p-button icon="pi pi-plus tw-text-sm" (click)="selectItem()" />
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th></th>
          <th>Name</th>
          <th>Options</th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr [class.!tw-bg-gray-300]="item.MenuIds.includes(_menu?.Id)" [class.!tw-bg-green-300]="_item?.Id == item.Id">
          <td></td>
          <td [routerLink]="[basePath,'menu',businessId,'panel','item',item.Id]" class="tw-cursor-pointer">
            @if(item.MenuIds.includes(_menu?.Id)){<i class="pi pi-check tw-mr-2"></i>}
            @if(_item?.Id == item.Id){<i class="pi pi-check-circle text-success tw-mr-2"></i>}
            {{item.Name}}
          </td>
          <td>{{item.Options?.length}}</td>
          <td>
            <p-menu #actionMenu [model]="item._actions" [popup]="true" appendTo="body"></p-menu>
            <i (click)="actionMenu.toggle($event)" [id]="'action-menu-'+item.Id"
              class="pi pi-ellipsis-h tw-text-sm tw-cursor-pointer"></i>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </ng-template>

  <ng-template pTemplate>
    <div class="tw-flex tw-flex-col tw-w-full tw-relative tw-min-h-full tw-border-solid tw-border-gray-400">
      <div
        class="tw-bg-gray-50 tw-w-full tw-text-center tw-p-7 tw-border-0 tw-border-b-[1px] tw-border-solid tw-border-gray-300 tw-font-bold">
        Customization</div>
      <div class="tw-flex tw-flex-col tw-m-1 tw-gap-2 tw-h-full">
        @if(_menu){
        <p-fieldset legend="Edit Menu">
          <div class="p-fluid p-formgrid tw-max-w-lg">
            <div class="field">
              <label htmlFor="name">Name</label>
              <input pInputText id="name" type="text" [(ngModel)]="_menu.Name" />
            </div>
            <div class="field">
              <p-checkbox binary="true" name="half" label="Support Half And Half?"
                [ngModel]="_menu.HalfAndHalfPrice != null"
                (ngModelChange)="_menu.HalfAndHalfPrice = $event ? 0 : null"></p-checkbox>
            </div>
            <div class="field" *ngIf="_menu.HalfAndHalfPrice != null">
              <label for="half">Extra Added Price for Half&Half</label>
              <input pInputText type="number" name="halfandhalf" [(ngModel)]="_menu.HalfAndHalfPrice" />
            </div>
          </div>
        </p-fieldset>

        <p-fieldset legend="Menu Default Options">
          <ng-container *ngTemplateOutlet="optionTemplate; context: { options: _menu.Options }"></ng-container>
        </p-fieldset>
        }
        @else if(_item)
        {
        <p-fieldset legend="Edit Menu Item">
          <div class="p-fluid p-formgrid tw-max-w-lg">
            <div class="field">
              <label htmlFor="name">Name</label>
              <input pInputText id="name" type="text" [(ngModel)]="_item.Name" />
            </div>
            <div class="field">
              <p-checkbox binary="true" name="half" label="Support Half And Half?"
                [ngModel]="_item.HalfAndHalfPrice != null"
                (ngModelChange)="_item.HalfAndHalfPrice = $event ? 0 : null"></p-checkbox>
            </div>
            <div class="field" *ngIf="_item.HalfAndHalfPrice != null">
              <label for="half">Extra Added Price for Half&Half</label>
              <input pInputText type="number" name="halfandhalf" [(ngModel)]="_item.HalfAndHalfPrice" />
            </div>
          </div>
        </p-fieldset>
        @if(_itemMenus?.length){
        @for(menu of _itemMenus;track $index){
        <p-fieldset [legend]="'Options from '+menu.Name+' menu'">
          <ng-container
            *ngTemplateOutlet="optionTemplate; context: {options: menu.Options, editlink: [basePath,'menu',businessId,'panel','menu',menu.Id]}"></ng-container>
        </p-fieldset>
        }
        }

        <p-fieldset legend="Menu Item Options">
          <ng-container *ngTemplateOutlet="optionTemplate; context:  {options:_item.Options}"></ng-container>
        </p-fieldset>
        }
      </div>

      @if(_menu || _item){
      <div class="tw-sticky tw-bottom-0 tw-z-50 tw-flex tw-justify-end tw-p-2 tw-bg-slate-100">
        @if(_menu){<button pButton label="Save Menu" icon="pi pi-save" (click)="saveMenu(_menu)"></button>}
        @if(_item){<button pButton label="Save Menu Item" icon="pi pi-save" (click)="saveItem(_item)"></button>}
      </div>
      }
    </div>
  </ng-template>

  <ng-template pTemplate>
    <p-table [value]="options" class="tw-w-full" (onEditComplete)="saveOption($event)" (onEditInit)="onEditInit($event)"
      (onEditCancel)="onEditCancel(options,$event)" (onRowReorder)="setOrder($event)">
      <ng-template pTemplate="caption">
        <div class="flex align-items-center justify-content-between">
          Options
          <p-button icon="pi pi-plus tw-text-sm" (click)="addOption()" />
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th></th>
          <th>Type</th>
          <th>Name</th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-option let-index="rowIndex" let-data="rowData">
        <tr [pReorderableRow]="index">
          <td><span class="pi pi-bars" pReorderableRowHandle></span>
          </td>
          <td pEditableColumn="{{option.Type}}" pEditableColumnField="Type" [pEditableColumnRowIndex]="index">
            <p-cellEditor>
              <ng-template pTemplate="input">
                <p-dropdown [options]="types" [(ngModel)]="option.Type" appendTo="body"></p-dropdown>
              </ng-template>
              <ng-template pTemplate="output">{{option.Type}}</ng-template>
            </p-cellEditor>
          </td>
          <td [pEditableColumn]="option.Name" pEditableColumnField="Name" [pEditableColumnRowIndex]="index"
            [pEditableRow]="rowData">
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input pInputText type="text" [(ngModel)]="option.Name" />
              </ng-template>
              <ng-template pTemplate="output">{{option.Name}}</ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-menu #actionMenu [model]="option._actions" [popup]="true" appendTo="body"></p-menu>
            <i (click)="actionMenu.toggle($event)" [id]="'action-menu-'+option.Id"
              class="pi pi-ellipsis-h tw-text-sm tw-cursor-pointer"></i>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </ng-template>
</p-splitter>


<ng-template #optionTemplate let-list="options" let-editlink="editlink">
  <p-accordion>
    @for(option of list;track $index){
    <p-accordionTab>
      <ng-template pTemplate="header">
        <div class="tw-flex tw-justify-between tw-w-full tw-gap-2">
          <div>[{{option.Type}}]</div>
          <div class="tw-grow">{{option.Name}}</div>
          <div>Selection: [{{option.MinSelection}} - {{option.MaxSelection}}] {{option.FreeSelection}} free</div>
        </div>
      </ng-template>

      <div class="tw-flex tw-flex-col tw-gap-2">
        <div>Json: <ng-container *ngTemplateOutlet="jsonData; context: {$implicit: {option}}"></ng-container></div>
        @if(!editlink){
        <p-fieldset legend="Edit Option">
          <div class="p-fluid p-formgrid tw-w-full tw-grid tw-grid-cols-2 tw-gap-1">
            <div class="field">
              <label>Type</label>
              <p-dropdown [options]="types" [(ngModel)]="option.Type"></p-dropdown>
            </div>
            <div class="field">
              <label htmlFor="name">Title</label>
              <input pInputText id="name" type="text" [(ngModel)]="option.Name" />
            </div>
            <div class="field">
              <label htmlFor="min-selection">Min Selection</label>
              <input pInputText id="min-selection" type="number" [(ngModel)]="option.MinSelection" />
            </div>
            <div class="field">
              <label htmlFor="max-selection">Max Selection</label>
              <input pInputText id="max-selection" type="number" [(ngModel)]="option.MaxSelection" />
            </div>
            <div class="field">
              <label htmlFor="free-selection">Free Selection</label>
              <input pInputText id="free-selection" type="number" [(ngModel)]="option.FreeSelection" />
            </div>
            <div class="field">
              <label htmlFor="max-changeable-default">Max Changeable Default</label>
              <input pInputText id="max-changeable-default" type="number" [(ngModel)]="option.MaxChangeableDefault" />
            </div>
          </div>
        </p-fieldset>
        }
        @else{
        <div class="field">
          <button pButton label="Edit" icon="pi pi-check" [routerLink]="editlink"></button>
        </div>
        }
      </div>

      <p-table [value]="option.Choices">
        <ng-template pTemplate="header">
          <tr>
            <th>Name</th>
            <!-- <th>Max Selection</th> -->
            <th>For Option</th>
            <th>Half & Half</th>
            <th>Price</th>
            <th></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-choice>
          @if(_options[choice.MenuOptionId]; as _option){
          @if(!choice.Prices?.length){
          <tr>
            <td>
              {{_option.Name}}
              <!-- <br/>{{choice.MaxSelection}} -->
            </td>
            <td>
              <p-checkbox binary="true" name="disable-half-and-half" label="Not available"
                [(ngModel)]="choice.DisabledForHalfAndHalf"></p-checkbox>
            </td>
            <td colspan="3">
              <i class="pi pi-plus tw-text-green-500 tw-cursor-pointer" (click)="choice.Prices.push({})"></i>
            </td>
          </tr>
          }
          @else{
          @for(price of choice.Prices; track $index){
          <tr>
            @if(!$index){
            <td [rowSpan]="choice.Prices.length">
              {{_option.Name}}
              <!-- <br/>{{choice.MaxSelection}} -->
              <div class="tw-mt-1 tw-text-xs tw-font-semibold tw-text-orange-700" *ngIf="choice.DisabledForHalfAndHalf">
                Not available for Half & Half
              </div>
            </td>
            }
            @if(!$index){
            <td [rowSpan]="choice.Prices.length">
              <p-checkbox binary="true" name="disable-half-and-half" label="Not available"
                [(ngModel)]="choice.DisabledForHalfAndHalf"></p-checkbox>
            </td>
            }
            <td>
              <p-dropdown [options]="options" [(ngModel)]="price.MenuOptionId" optionLabel="Name" optionValue="Id"
                [showClear]="true" placeholder="Any" appendTo="body"></p-dropdown>
            </td>
            <td>
              <input pInputText id="price" type="number" [(ngModel)]="price.Price" placeholder="Price" />
            </td>
            <td>
              <i class="pi pi-times text-danger tw-cursor-pointer" (click)="choice.Prices.splice($index,1)"></i>
              @if($index == choice.Prices.length - 1){
              <i class="pi pi-plus tw-text-green-500 tw-cursor-pointer" (click)="choice.Prices.push({})"></i>
              }
            </td>
          </tr>
          }
          }
          }
        </ng-template>
      </p-table>
    </p-accordionTab>
    }
  </p-accordion>
</ng-template>

<ng-template #jsonData let-data><i class="pi pi-info-circle tw-cursor-pointer" (click)="tooltip=data"></i></ng-template>
<p-dialog header="Json Detail" [visible]="!!tooltip" (visibleChange)="tooltip=null" [style]="{'min-width': '50vw'}"
  [dismissableMask]="true">
  <pre>{{tooltip|json}}</pre>
</p-dialog>


<p-dialog [header]="(selectedMenu?.Id ? 'Edit' : 'New') + ' Menu'" [visible]="!!selectedMenu"
  (visibleChange)="selectedMenu=null" [modal]="true" [maximizable]="true" [style]="{ 'min-width': '50vw' }">
  @if(selectedMenu){<brt-menu-save [menu]="selectedMenu" (saved)="selectedMenu=null;load()"></brt-menu-save>}
</p-dialog>

<p-dialog [header]="(selectedItem?.Id ? 'Edit' : 'New') + ' Menu Item'" [visible]="!!selectedItem"
  (visibleChange)="selectedItem=null" [modal]="true" [maximizable]="true" [style]="{ 'min-width': '50vw' }">
  @if(selectedItem){<brt-menu-item-save [item]="selectedItem" (saved)="selectedItem=null;load()"></brt-menu-item-save>}
</p-dialog>

<!-- <p-dialog [header]="(selectedOption?.Id ? 'Edit' : 'New') + ' Option'" [visible]="!!selectedOption"
    (visibleChange)="selectedOption=null" [modal]="true" [maximizable]="true" [style]="{ 'min-width': '50vw' }">
    @if(selectedOption){<brt-menu-option-save [option]="selectedOption"
      (saved)="selectedOption=null;load()"></brt-menu-option-save>}
  </p-dialog> -->

<p-confirmPopup key="confirmPopup"></p-confirmPopup>
<p-toast></p-toast>